type FlagSize = 16 | 24 | 32 | 48;

interface FlagOptions {
  size?: FlagSize;
  retina?: boolean;
}

export function useCountryFlag(
  countryCode?: string,
  options: FlagOptions = {}
) {
  const { size = 16, retina = true } = options;

  if (!countryCode) {
    return null;
  }

  const code = countryCode.toLowerCase();

  const width = size;
  const height = Math.round((size * 3) / 4); // keep ratio

  const base = `https://flagcdn.com`;

  const src = `${base}/${width}x${height}/${code}.png`;

  const srcSet = retina
    ? `
      ${base}/${width * 2}x${height * 2}/${code}.png 2x,
      ${base}/${width * 3}x${height * 3}/${code}.png 3x
    `
    : undefined;

  return {
    src,
    srcSet,
    width,
    height,
    alt: countryCode.toUpperCase(),
  };
}